export default __webpack_public_path__ + "static/media/small-search.10580047.svg";